import { COLOR1 } from '../../../constants';

export const productHeadingInfo = {
  marginBottom: '15px',
  textAlign: 'left',
  width: 'fit-content',
  fontFamily: 'TTNormsProBold',
  letterSpacing: '0.14px',
  '@media (max-width:650px)': {
    font: 'normal 700 28px/33px TTNormsProBold',
    letterSpacing: '0.11px',
  },
};

export const productSubHeadingInfo = {
  marginBottom: '20px',
  letterSpacing: '0.11px',
  fontWeight: 700,
};
